/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGlobalAnnouncementsResponse } from '../../models/get-global-announcements-response';

export interface GetGlobalAnnouncements$Params {
}

export function getGlobalAnnouncements(http: HttpClient, rootUrl: string, params?: GetGlobalAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGlobalAnnouncementsResponse>> {
  const rb = new RequestBuilder(rootUrl, getGlobalAnnouncements.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGlobalAnnouncementsResponse>;
    })
  );
}

getGlobalAnnouncements.PATH = '/public/announcements';
